import cx from "classnames";
import React from "react";

import { Anchor } from "@/components/elements/Anchor";
import {
  Illustration,
  IllustrationType,
} from "@/components/elements/Illustration";
import { Text } from "@/components/elements/Text";
import { PageLink } from "@/types/types";

import styles from "./styles.module.css";

type CtaProps =
  | {
      page: PageLink;
      linkText: string;
    }
  | {
      page?: never;
      linkText?: never;
    };

export type StatusPageContentProps = {
  title: string;
  illustration?: IllustrationType;
  copy?: string;
  className?: string;
} & CtaProps;

export const StatusPageContent = ({
  title,
  illustration,
  copy,
  page,
  linkText,
  className,
}: StatusPageContentProps) => {
  return (
    <div className={cx(styles.container, className)}>
      {illustration && (
        <Illustration type={illustration} className={styles.illustration} />
      )}
      <Text as="h1" size="l" className={styles.title}>
        {title}
      </Text>
      {copy && <Text className={styles.copy}>{copy}</Text>}
      {page && (
        <Text size="xs" className={styles.linkContainer}>
          <Anchor pageLink={page}>{linkText}</Anchor>
        </Text>
      )}
    </div>
  );
};
